import {
  BackgroundColorProps,
  border,
  BorderProps,
  boxShadow,
  BoxShadowProps,
  color,
  compose,
  css,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { ContainerStyleProps, DisplayOnProps, xlBumps } from '../layout'
import { gap, GapProps } from './gap'

export type FooterContainerVariants = 'default'

export interface FooterContainerProps
  extends BackgroundColorProps,
    BorderProps,
    BoxShadowProps,
    ContainerStyleProps,
    DisplayOnProps,
    FlexboxProps,
    GapProps,
    LayoutProps,
    PositionProps,
    SpaceProps {
  variant?: FooterContainerVariants
}

const defaultProps = withDefaultProps<FooterContainerProps>({
  variant: 'default',
})

export const FooterContainer = styled.footer.attrs<FooterContainerProps>(defaultProps)(
  css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'surfaceFooter',
    py: xlBumps,
  }),
  variant({
    scale: 'FooterContainer',
    variants: {
      default: {},
    },
  }),
  compose(flexbox, layout, space, border, color, position, gap, boxShadow),
)
